import ConfigModel from "./ConfigModel"
import UserModel from "./UserModel"

export default class InnovationsModel {
    configModel
    userModel

    constructor() {
        this.configModel = new ConfigModel()
        this.userModel = new UserModel()
    }

    async GetInnovations() {
        let url = `${this.configModel.api}get_activities`
        let data = {
            "access_key": "8525",
            "language_id": "34",
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            if (!response_data.error) {
                return response_data.data
            } else {
                return []
            }
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async SetInnovation(activity_id, title, details, entered_url, start_date, end_date) {
        let url = `${this.configModel.api}submit_innovations`
        let data = {
            "access_key": "8525",
            "activity_id": activity_id,
            "title": title,
            "details": details,
            "url": entered_url,
            "start_date": start_date,
            "end_date": end_date,
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            return response_data
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async GetSubmittedInnovations(page = 1, limit = 7) {
        let url = `${this.configModel.api}get_private_feeds`
        let data = {
            "access_key": "8525",
            "page": page,
            "limit": limit,
            "type": "activity"
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            console.log("get_private_feeds",response_data.error)
            // if (!response_data.error) {
            //     return response_data.data
            // } else {
            //     return []
            // }
            return response_data
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async GetStudentSubmissionById(user_id, page = 1, limit = 4) {
        let url = `${this.configModel.api}get_feeds`
        let data = {
            "access_key": "8525",
            "page": page,
            "limit": limit,
            "user_id": user_id
        }
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            if (!response_data.error) {
                return response_data.data
            } else {
                return []
            }
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }

    async CancelSubmission(feed_id) {
        let url = `${this.configModel.api}cancel_submission`
        let data = {
            "access_key": "8525",
            "feed_id": feed_id
        }
        console.log("data ", data)
        let userData = this.userModel.GetUserFromLocal()
        let authorization = userData.data.api_token

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authorization}`,
                },
                body: JSON.stringify(data)
            })

            const response_data = await response.json()
            return response_data
        } catch (err) {
            console.error("post request failed ", err)
            return err
        }
    }
    // async uploadFileToPHP(file) {
    //     let url = `${this.configModel.api}video_upload`
    //     let data = {
    //         "access_key": "8525",
    //         "file_array": file
    //     }
    //     let userData = this.userModel.GetUserFromLocal()
    //     let authorization = userData.data.api_token
    //     try {
    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Authorization": `Bearer ${authorization}`,
    //             },
    //             body: JSON.stringify(data)
    //         })
        
    //       const result = await response.json();
    //       if (result.status === "success") {
    //         console.log("Uploaded to:", result);
    //       } else {
    //         console.error("Upload failed:", result);
    //       }
    //     } catch (error) {
    //       console.error("Error uploading file:", error);
    //     }
    //   }
    async uploadFileToPHP(file) {
        const url = `${this.configModel.api}video_upload`;
        const userData = this.userModel.GetUserFromLocal();
        const authorization = userData.data.api_token;
    
        // Prepare FormData
        const formData = new FormData();
        formData.append("access_key", "8525");
        formData.append("file_array", file);  // Ensure this matches the PHP key
    
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${authorization}`
                    // Do NOT set 'Content-Type' manually for FormData
                },
                body: formData
            });
    
            const result = await response.json();
            if (result.status === "success") {
                console.log("Uploaded to:", result.url);
                return {
                    url: result.url                    
                };
            } else {
                console.error("Upload failed:", result);
            }
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    }
    
      
}